<template>
  <div v-show="value" class="cust-loading-box-sty">
    <div class="cust-loading-sty"></div>
  </div>
</template>
<script>
export default {
  props: { value: { type: Boolean, default: true }, inline: { type: Boolean, default: false } },
  data () {
    // 这里存放数据
    return {}
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { },
}
</script>
<style lang='less' scoped>
// @import url(); 引入公共css类
.cust-loading-box-sty {
  width: 100%;
  height: calc(100vh - 60px);
  position: absolute;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  .cust-loading-sty {
    width: 100px;
    height: 100px;
    background: url("/static/images/icon/loading2.gif") no-repeat;
    background-size: 100% 100%;
  }
}
</style>


// WEBPACK FOOTER //
// components/publicCom/custLoading/index.vue